/**
 * getCookie returns the value of a cookie if it exists, simply provide the name of the cookie
 * @param {string} name
 */
const getCookie = (name) => {
  const cookies = document.cookie.split('; ');

  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=');
    if (name === cookieName) {
      return cookieValue;
    }
  }
};

/**
 * getHost returns a host based on countryIso and app env
 * @param {string} countryiso - se/dk/de etc.
 * @param {string} env - e.g. test, local or prod
 * @param {string} subdomain - could be used if we're on e.g. test04
 */
const getHost = (countryiso, env, subdomain) => {
  const mofibo = countryiso === 'dk';
  if (env === 'test' && subdomain) {
    return (subdomain == 'localhost' ? 'http' : 'https') + '://' + subdomain + '.storytel.com';
  } else if (mofibo) {
    return 'https://mofibo.com';
  }

  return 'https://www.storytel.com';
};

/**
 * prefixHostToLinks prefixes relative links with a host.
 * @param {string} countryiso - se/dk/de etc.
 * @param {string} language - sv/da/de etc.
 * @param {string} host - e.g. https://www.storytel.com
 * @param {object} data - a top/bottom nav object
 */
const prefixHostToLinks = (countryiso, language, host, data) => {
  const stringifiedData = JSON.stringify(data);
  const rgx = new RegExp(`"\/${countryiso}\/${language}\/`, 'g');
  const replacedData = stringifiedData.replace(rgx, `"${host}\/${countryiso}\/${language}\/`);
  const parsedData = JSON.parse(replacedData);
  return { ...parsedData, data: { ...parsedData.data, countryIso: countryiso, language } };
};

/**
 * Simple non-secure hash function.
 * @param str
 * @returns {string}
 */
const simpleHash = (str) => {
  str = '' + str;
  const length = str.length;
  let hash = 1;
  for (let i = 0; i < length; i++) {
    hash = (hash * 36) ^ str.charCodeAt(i);
  }
  // Convert from 32-bit signed to unsigned, and then to base36 string.
  return (hash >>> 0).toString(36);
};

module.exports = { getCookie, getHost, prefixHostToLinks, simpleHash };
